import React from "react";
import { Container, Flex, Title, TilesContainer, Tile, TileImage, Text } from "../ui";
import styled from "styled-components";
import { Navigation, SVGCarousel } from "../components";
import { WindowSize } from "react-fns";
import * as image1 from "../assets/image1.jpg";
import * as image2 from "../assets/image2.png";
import { Marquee } from "../ui/animations";
import InlineSVG from "svg-inline-react";
import { DESIGN } from "../assets/svg";

const HomeContainer = styled.section`
  height: 75vh;
  max-width: 82.5vw;
  position: relative;
  margin: auto;
  @media (max-width: 769px) {
    max-width: 66vw;
    margin: 0 auto 0 30px;
  }
`;

const links = [
  { text: "Team", path: "/team", uLineW: "66px" },
  { text: "Contact", path: "/contact", uLineW: "120px" }
];

const Home = () => {
  return (
    <WindowSize
      render={({ width }) => (
        <>
          <TilesContainer>
            {width >= 769 ? (
              <>
                <div className="svg--wrapper">
                  <InlineSVG src={DESIGN} />
                </div>
                <Tile style={{ flex: 0.5 }} />
                <Tile />
                <Tile />
                <Tile />
                <Tile top>
                  <TileImage src={image1} height={1.5} />
                </Tile>
                <Tile span={1.5}>
                  <TileImage src={image2} height={1} />
                </Tile>
              </>
            ) : (
              <>
                <div className="svg--wrapper">
                  <InlineSVG src={DESIGN} />
                </div>
                <Tile />
                <Tile />
                <Tile>
                  <TileImage flip src={image2} height={1} position="right"/>
                </Tile>
              </>
            )}
          </TilesContainer>
          <HomeContainer>
            <Flex column justifyContent="flex-end" fillHeight>
              <div className="titles--container">
                <Title percentage="1" width="267px" bold={false} >
                  We develop
                </Title>
                <Title percentage="2" dash>
                  Your ideas
                </Title>
              </div>
              <Text>
                UON is an IT company based in Belgrade, Serbia. We build custom software solutions and specialise in web and mobile app development.  Our company also has expertise in blockchain development. <br />We provide valuable market intelligence, opportunities for establishing a strong position with the most valuable industry engineers, and access to its own network of clever and efficient blockbuster candidates to create and implement a long-term strategy.
                <br />
                  We are active every day to resolutely master the current mission and continue to deliver the most advanced UX as well as to create an IM that is intuitive to the latest standards.

              </Text>
              <Navigation links={links} />
            </Flex>
          </HomeContainer>
        </>
      )}
    />
  );
};

export default Home;
